/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
  'use strict';
  import IProfile = Models.IProfile;
  import IStreamPipeElement = Models.IStreamPipeElement;
  import BlockTypeNaturalKey = Application.Models.BlockTypeNaturalKey;
  import Utils = Common.Utils;

  export class PipeViewerController {
    public static $name: string = 'pipeViewerController';
    public static $inject: string[] = [
      '$scope',
      '$routeParams',
      'streamPipeService',
      'presetPathService',
      '$q',
      '$window',
      'deviceGuiService',
      '$sce',
      'connectionRoomService',
      'videoFeedService',
      'streamStatusService',
      '$interval',
      '$timeout',
      'timezoneService',
      '$location',
      '$cookies',
      'alarmsService',
      'profileService',
      'flexCollectorService',
      'messageTranslationsService',
      'networkNodeTypeService',
      'userService',
      'aclService',
      '$rootScope',
      '$q',
      'blockService'
    ];

    public static COOKIE_OPTIONS: ng.cookies.ICookiesOptions = {
      expires: Utils.getCookieExpirationDate(),
      secure: location.protocol === 'https:'
    };
    public static COOKIE_PIPE_STEP_KEY: string = 'flex_pipe_step_';
    public static PARSE_BLOCK_INFO_DELAY: number = 5000;
    private static STREAM_DATA_TIMER: number = 5000;
    private streamId: number;
    private streamPipe: Models.IStreamPipe;
    private videoFeeds: Models.VideoFeed[];
    private plotTimer: ng.IPromise<void>;
    private getDataTimer: ng.IPromise<void>;
    private currentBitrateMbps: number[] = [];
    private txInfo: boolean;
    private sinkId: string;
    private profileLoaded: boolean = false;

    private currentElementIndex: number;
    private pipeElements: Models.IStreamPipeElement[];
    private devicesUrls: string[];
    private devicesGuiUrls: string[];
    private stepsInfo: Controllers.IDigestedInfo[];
    private currentProfiles: IProfile[];
    private profileInterval: ng.IPromise<void>;
    private blockAudios: Models.FullAudioInfo[][];
    private parseBlockInfoTimer: ng.IPromise<{}>;
    private profilesEditionMode: boolean;
    private fakePresets: {
      name: string;
    }[];
    private canReadSupport: boolean = false;

    private blockI: Models.IBlock;
    private isTs: boolean;

    private maxSynthValues: number;
    private numSynthValues: number;
    private trendingInfo: Models.TrendingInfo;

    private reRender: boolean = true;
    private timezoneChanged: Function;
    private stompReconnectUnsubscribe: Function;
    private presetConnections: boolean[];
    private hasTwoBitrates: boolean = false;
    public devicesIdsNodesEnum: any = {
      MVP_AGILE: 7,
      MVP_O4: 5,
      MVP_O2: 4,
      MVP_IO: 3,
    }

    constructor(
      private $scope: ng.IScope,
      private $routeParams: ng.route.IRouteParamsService,
      private streamPipeService: Services.StreamPipeService,
      private presetPathService: Services.PresetPathService,
      private qService: ng.IQService,
      private $window: ng.IWindowService,
      private deviceGuiService: Services.DeviceGuiService,
      private $sce: ng.ISCEService,
      private connectionRoomService: Services.ConnectionRoomService,
      private videoFeedService: Services.VideoFeedService,
      private streamStatusService: Services.StreamStatusService,
      private $interval: ng.IIntervalService,
      private $timeout: ng.ITimeoutService,
      private timezoneService: Services.TimezoneService,
      private $location: ng.ILocationService,
      private $cookies: ng.cookies.ICookiesService,
      private alarmService: Services.AlarmsService,
      private profileService: Services.ProfileService,
      private flexCollectorService: Services.FlexCollectorService,
      private messageTranslationsService: Services.MessageTranslationsService,
      private networkNodeTypeService: Services.NetworkNodeTypeService,
      private userService: Services.UserService,
      private aclService: Services.AclService,
      private $rootScope: Services.IFlexSettings,
      private $q: ng.IQService,
      private blockService: Services.BlockService
    ) {
      this.initValues();
      this.initBindings();
    }

    public getNodeIcon(nodeType: Models.INetworkNodeType): string {
      if (nodeType.href === undefined || nodeType.href === '') {
        return 'images/iconmonstr-server-4-240-not-checked.png';
      } else {
        let typeId: number = Utils.idFromHref(nodeType.href);
        return `images/nodeTypes/${typeId}.png`;
      }
    }

    public async openDeviceGui(): Promise<void> {
      await this.getDevicesUrls();

      if (!!this.devicesUrls[this.currentElementIndex]) {
        let deviceGui: Models.DeviceGui = new Models.DeviceGui();
        deviceGui.proxyType = this.$rootScope.backendConfig.flexoProxyType;
        deviceGui.guiUrl = this.devicesUrls[
          this.currentElementIndex
        ].toString();
        this.deviceGuiService.notifyAdminSettingsAttempt(
          this.streamPipe.sourceNodeHref,
          deviceGui
        );
        this.$window.open(deviceGui.guiUrl, '_blank');
      } else {
        this.messageTranslationsService.alertOnError(
          'Something was wrong: device unreachable.',
          'bottom-center'
        );
      }
    }

    public openSupportToolkit(): string {
      if (
        this.pipeElements === undefined ||
        !this.pipeElements[this.currentElementIndex].networkNodeI.href
      )
        return;
      return `#!/support/${Utils.idFromHref(
        this.pipeElements[this.currentElementIndex].networkNodeI.href
      )}/support-toolkit`;
    }

    public onVideoPlayAttempt(): void {
      this.videoFeedService.notifyVideoPlayAttemptByStreamPipeId(
        this.streamId,
        this.videoFeeds[this.currentElementIndex]
      );
    }

    public onVideoPlayError(): void {
      this.videoFeedService.notifyVideoPlayErrorByStreamPipeId(
        this.streamId,
        this.videoFeeds[this.currentElementIndex]
      );
    }

    public changePipeStep(index: number): void {
      if (index !== this.currentElementIndex) {
        if (this.plotTimer !== undefined) this.$interval.cancel(this.plotTimer);

        this.currentElementIndex = index;
        const iStreamPipeElement = this.pipeElements
          ? this.pipeElements[this.currentElementIndex]
          : undefined;
        if (iStreamPipeElement) {
          this.blockI = iStreamPipeElement.blockI;
          this.isTs = this.isTsPipeElement(iStreamPipeElement);
        }

        if (this.trendingInfo) {
          this.trendingInfo.close();
          this.trendingInfo = undefined;
        }
        this.getStreamIdAndStreamElements();
        this.txInfo = true;
        this.profilesEditionMode = false;
        this.$cookies.put(
          PipeViewerController.COOKIE_PIPE_STEP_KEY + this.streamId,
          this.currentElementIndex.toString()
        );
      }
    }

    private isTsPipeElement(
      iStreamPipeElement: Models.IStreamPipeElement
    ): boolean {
      return (
        (this.isMulticast(this.blockI) &&
          iStreamPipeElement.outgoingConnection &&
          iStreamPipeElement.outgoingConnection.origBlockConnection
            .connectionTypeName === 'TSoIP') ||
        (this.isVTSD(iStreamPipeElement) &&
          iStreamPipeElement.incomingConnection &&
          iStreamPipeElement.incomingConnection.destBlockConnection
            .connectionTypeName === 'TSoIP')
      );
    }

    public isVirtSrtRxCall(iStreamPipeElement: Models.IStreamPipeElement): boolean {
      return (
        iStreamPipeElement.blockI.blockTypeNaturalKey ===
        BlockTypeNaturalKey.VIRT_SRT_RX_CALL
      );
    }
    
    public isVirtSrtTxCall(iStreamPipeElement: Models.IStreamPipeElement): boolean {
      return (
        iStreamPipeElement.blockI.blockTypeNaturalKey ===
        BlockTypeNaturalKey.VIRT_SRT_TX_CALL
      );
    }

    private isVTSD(iStreamPipeElement: Models.IStreamPipeElement): boolean {
      return (
        iStreamPipeElement.blockI.blockTypeNaturalKey ===
        BlockTypeNaturalKey.V_TS_DESTINATION
      );
    }

    public isVirtSrtRxLstn(iStreamPipeElement: Models.IStreamPipeElement): boolean {
      return (
        iStreamPipeElement.blockI.blockTypeNaturalKey ===
        BlockTypeNaturalKey.VIRT_SRT_RX_LSTN
      );
    }
    public isVirtSrtTxLstn(iStreamPipeElement: Models.IStreamPipeElement): boolean {
      return (
        iStreamPipeElement.blockI.blockTypeNaturalKey ===
        BlockTypeNaturalKey.VIRT_SRT_TX_LSTN
      );
    }

    private isSrtGwRxLstn(iStreamPipeElement: Models.IStreamPipeElement): boolean {
      return (
        iStreamPipeElement.blockI.blockTypeNaturalKey ===
        BlockTypeNaturalKey.SRT_GW_RX_LSTN
      );
    }

    private isMulticast(block: Models.IBlock): boolean {
      return block &&
        typeof block.config.ts !== 'undefined' &&
        typeof block.config.ts.ip !== 'undefined'
        ? Common.IpUtils.ipIsMulticast(block.config.ts.ip)
        : false;
    }

    public saveProfile(profile: IProfile): void {
      if (
        this.currentElementIndex !== undefined &&
        this.pipeElements[this.currentElementIndex] !== undefined
      ) {
        let blockId: number = this.pipeElements[this.currentElementIndex]
          .blockId;
        this.profileService.saveProfile(blockId, profile);
      }
    }

    public countOptions(options: Object): number {
      if (options) {
        return Object.keys(options).length;
      }
      return 0;
    }

    public toggleProfilesEditionMode(): void {
      this.profilesEditionMode = !this.profilesEditionMode;
    }

    public toggleTxInfo(newStatus: boolean): void {
      if (newStatus === false) {
        this.profilesEditionMode = false;
      }
      this.txInfo = newStatus;
    }

    public audioLevelUnavailable(audioLevel: number): boolean {
      return isNaN(audioLevel) || audioLevel === undefined;
    }

    /**
     * @param param: name of the param being searched for the current element (block) in the pipe
     * Returns param value
     */
    // Review the flow in this method
    public getBlockParam(param: string): string | number | boolean {
      if (this.stepsInfo[this.currentElementIndex] === undefined) {
        return;
      }
      let parameters: IDigestedInfo = this.stepsInfo[this.currentElementIndex];
      if (this.pipeElements[1].blockI.config.isRedundant == true && this.blockI.config.isRedundant) {
        parameters["sourceDevice"] = this.pipeElements[0].blockI.config.ts.ip + ":" + this.pipeElements[0].blockI.config.ts.port;
      }
      if (param === 'video.codec') {
        return this.getVideoCodecParam();
      }
      if (param === 'srtUrlIp') {
          if (parameters['srtHost']) {
              return parameters['srtHost'];
          } else {
              let urlParams = parameters["srtUrl"].toString().split(":");
              let ip = urlParams[1].substring(2);
              return ip;
          }
      }
      if (param === 'srtUrlPort') {
        if (parameters['srtPort']) {
          return parameters['srtPort'];
        } else {
          return Utils.getUrlParam(parameters["srtUrl"].toString(), "port");
        }
      }
      if (param === 'srtUrlPassphrase') {
        if (parameters['srtPassphrase']) {
          return parameters['srtPassphrase'];
        } else {
          return Utils.getUrlParam(parameters["srtUrl"].toString(), "passphrase");
        }
      }
      if (param === 'srtUrlMode') {
        if (parameters['srtMode']) {
          return parameters['srtMode'];
        } else {
          return Utils.getUrlParam(parameters["srtUrl"].toString(), "mode");
        }
      }
      let paramValue: string | number | boolean = parameters[param];
      if (param === 'received' || param === 'sent') {
        if (typeof paramValue === 'string') {
          paramValue = Utils.kibiHumanReadableBits(parseInt(paramValue, 10), 2);
        } else if (typeof paramValue === 'number') {
          paramValue = Utils.kibiHumanReadableBits(paramValue, 2);
        }
      }

      return paramValue;
    }

    public hasHistorical(index: number): boolean {
      const block: Models.IBlock = this.pipeElements[index].blockI;
      return !(
        block.blockTypeNaturalKey === BlockTypeNaturalKey.MVP_SERVER ||
        block.blockTypeNaturalKey === BlockTypeNaturalKey.MVP_SERVER_TS
      );
    }

    public showHistoricalTraffic(): void {
      if (!this.pipeElements[this.currentElementIndex].hasHistorical) {
        return;
      }
      const blockId: number = this.pipeElements[this.currentElementIndex]
        .blockId;
      const networkNodeId: string = this.pipeElements[this.currentElementIndex]
        .networkNodeI.id;
      this.$location.path(
        '/historicalByClient/' + networkNodeId + '/' + blockId
      );
    }

    /**
     * Execute and show MVP Data Table if condition is applied
     * @param networkTypeArray 7: Flex_Agile, 5: Flex_O4, 4: Flex_O2, 3: Flex_OI
     */
    public showIfHaveRightDevice(networkTypeArray: any) {
      let res = false
      if (this.pipeElements) {
        const deviceTypes: any = ["MVP_CLIENT", "MVP_SERVER"];
        const deviceType: string = this.pipeElements[this.currentElementIndex].blockI.blockTypeNaturalKey;
        const nodeTypeId: number = +this.pipeElements[this.currentElementIndex].blockI.networkNodeTypeHref;
        //Special case: Encoder IO must not be displayed
        res = !(deviceType === "MVP_CLIENT" && nodeTypeId === this.devicesIdsNodesEnum.MVP_IO) &&
            deviceTypes.includes(deviceType) &&
            networkTypeArray.includes(nodeTypeId);
      }
      return res;
    }

    /**
     * This method calls the backend in order to get the device params of a pipe element's (marked by the index)
     * block id and stores it in global variables stepsInfo and blockAudios
     * @param index: index of the pipe element being parsed
     */
    private parseBlockInfo(index: number): void {
      let blockId: number;
      if (this.pipeElements[index].blockI.config.isRedundant == true) {
        blockId = this.pipeElements[index].blockId - 1;
      } else {
        blockId = this.pipeElements[index].blockId;
      }
      this.flexCollectorService
        .getDeviceParamsBySimplifiedHref('blocks/' + blockId)
        .then((response: Models.DeviceParams) => {
          let blockInfo: Controllers.IDigestedInfo = {};
          for (let p of response.params) {
            blockInfo[p.name] = p.lastValue;
          }
          this.stepsInfo[index] = blockInfo;
          this.blockAudios[index] = response.getAudioInfo(blockInfo, undefined);
          this.pipeElements[index].srtflexUrl =
            BlockTypeNaturalKey.isPlayable(
              this.pipeElements[index].blockI.blockTypeNaturalKey
            ) && blockInfo['srtUrl']
              ? Utils.generateSrtURLWithFlexProtocol(
                  blockInfo['srtUrl'] as string
                )
              : undefined;
        });
    }

    private parseAllBlocksInfo(): void {
      for (let i: number = 0; i < this.pipeElements.length; i++) {
        this.parseBlockInfo(i);
      }
    }

    private getVideoCodecParam(): string {
      const videoCodecParamKey: string = 'video.codec';
      const parameters: IDigestedInfo = this.stepsInfo[
        this.currentElementIndex
      ];
      if (parameters[videoCodecParamKey] === undefined) {
        if (
          this.currentProfiles &&
          this.currentProfiles[this.currentElementIndex]
        ) {
          const [videocodec]: Models.IProfileParam[] = this.currentProfiles[
            this.currentElementIndex
          ].profileParams.filter(
            (profileParam: Models.IProfileParam) =>
              profileParam.paramName === 'videocodec'
          );
          return videocodec ? videocodec.paramValueDescription : '';
        } else {
          return '';
        }
      } else {
        const configuredBitrateParamKey: string = 'configuredBitrate';
        const videoPidParamKey: string = 'video.pid';
        const bitrate: number = parameters[configuredBitrateParamKey] as number;
        const pid: string = parameters[videoPidParamKey] as string;
        return (
          (parameters[videoCodecParamKey] as string) +
          (bitrate
            ? `, ${(bitrate / 1000000).toFixed(2)} Mbps`
            : ', bitrate N/A') +
          (pid ? ` - PID ${pid}` : '')
        );
      }
    }

    private async checkIfBlockIsRedundant(blockId: number): Promise<void> {
      let redundantInfo = await this.blockService.getRedundantBlocks(blockId);
      console.log('redundantInfo: ', redundantInfo);
      // return true;
    }

    private getStreamIdAndStreamElements(): void {
      this.streamId = parseInt(
        (this.$routeParams as { streamId: string }).streamId,
        10
      );
      if (this.streamId && this.streamId > 0) {
        this.streamPipeService
          .getStreamPipe(this.streamId.toString())
          .then((streamPipe: Models.IStreamPipe) => {
            this.streamPipe = streamPipe;
            let stepCookie: number = parseInt(
              this.$cookies.get(
                PipeViewerController.COOKIE_PIPE_STEP_KEY + this.streamId
              ),
              10
            );
            this.currentElementIndex = stepCookie ? stepCookie : 0;
          });
        if (!this.pipeElements) {
          this.streamPipeService
            .getStreamPipeViewByStreamId(this.streamId)
            .then((pipeElements: Models.IStreamPipeElement[]) => {
              console.log('pipeElements: ', pipeElements);
              this.pipeElements = pipeElements;
              this.blockI = this.pipeElements[this.currentElementIndex].blockI;
              this.isTs = this.isTsPipeElement(
                this.pipeElements[this.currentElementIndex]
              );
              this.pipeElements[
                this.currentElementIndex
              ].hasHistorical = this.hasHistorical(this.currentElementIndex);
              this.generateConnectionsInfo();
              this.getDevicesUrls();
              this.initTrending();
              this.loadVideoFeed(this.currentElementIndex);
              this.setPresetPath();
              this.parseBlockInfo(this.currentElementIndex);
              this.$interval.cancel(this.parseBlockInfoTimer);
              this.parseBlockInfoTimer = this.$interval(() => {
                this.parseBlockInfo(this.currentElementIndex);
              }, PipeViewerController.PARSE_BLOCK_INFO_DELAY);
              this.setSinkIdIfNeeded();
              this.currentProfiles = [];
              this.$interval.cancel(this.profileInterval);
              this.profileInterval = this.$interval(() => {
                this.qService
                  .all(
                    this.pipeElements
                      .map((pipeElement: IStreamPipeElement) => {
                        return pipeElement.blockId;
                      })
                      .map((blockId: number) => {
                        return this.profileService.loadProfile(blockId);
                      })
                  )
                  .then((profiles: IProfile[]) => {
                    this.currentProfiles.splice(0, this.currentProfiles.length);
                    this.profileLoaded = true;
                    for (let profile of profiles) {
                      this.currentProfiles.push(profile);
                    }
                  }).catch((reason: any) => {
                    this.profileLoaded = true;
                });
              }, PipeViewerController.PARSE_BLOCK_INFO_DELAY);
            });
        } else {
          this.pipeElements[
            this.currentElementIndex
          ].hasHistorical = this.hasHistorical(this.currentElementIndex);
          this.initTrending();
          this.parseAllBlocksInfo();
          this.loadVideoFeed(this.currentElementIndex);
          this.setPresetPath();
          this.setSinkIdIfNeeded();
        }
      }
    }

    /**
     * Method to set if needed the id to 'srt_url_sink' in the device-property component in case that is a VIRT_SRT_RX_CALL block
     * otherwise it will return empty string
     */
    private setSinkIdIfNeeded(): void {
      if (this.pipeElements) {
        this.sinkId = this.isVirtSrtRxCall(this.pipeElements[this.currentElementIndex])
          ? 'srt_url_sink'
          : '';
      }
    }

    private setPresetPath(): void {
      let promiseArr = this.pipeElements.map(
        (resource: Models.IStreamPipeElement) => {
          return this.getPresetPathBlock(resource.blockId).then(
            (data: string[]) => {
              resource.presetPath = data;
            }
          );
        }
      );

      Promise.all(promiseArr).then(() => {
        this.setPresetPathConnections();
      });
    }

    private getPresetPathBlock(blockId: number): Promise<string[]> {
      return this.presetPathService.getPresetPathBlock(
        blockId.toString()
      );
    }

    private setPresetPathConnections(): void {
      let presetCon = [];
      for (let i: number = 0; i < this.pipeElements.length - 1; i++) {
        presetCon.push(
          this.pipeElements[i].presetPath.some(
            r => this.pipeElements[i + 1].presetPath.indexOf(r) >= 0
          )
        );
      }
      this.presetConnections = presetCon;
    }

    private getDevicesUrls() {
      let promises: ng.IPromise<Models.DeviceGui>[] = [];
      let aclPromises: ng.IPromise<boolean>[] = [];
      for (let element of this.pipeElements) {
        promises.push(
          this.deviceGuiService.getDeviceGuiByBlockId(
            element.blockId.toString()
          )
        );
        aclPromises.push(
          this.aclService.canAccessGui(Number(element.networkNodeI.id))
        );
      }
      this.qService.all(promises).then((devicesUrls: Models.DeviceGui[]) => {
        this.devicesUrls = [];
        this.devicesGuiUrls = [];
        this.qService.all(aclPromises).then((canAccess: boolean[]) => {
          this.pipeElements.forEach(
            (element: Models.IStreamPipeElement, index: number) => {
              if (canAccess[index]) {
                this.devicesUrls.push(
                  this.$sce.trustAsResourceUrl(devicesUrls[index].guiUrl)
                );
                if (Utils.hasGuiInterface(element.networkNodeI.type.href)) {
                  this.devicesGuiUrls.push(
                    this.$sce.trustAsResourceUrl(
                      devicesUrls[index].guiUrl + 'gui'
                    )
                  );
                } else {
                  this.devicesGuiUrls.push(undefined);
                }
              } else {
                this.devicesUrls.push(undefined);
              }
            }
          );
        });
      });
    }

    private loadVideoFeed(index: number): void {
      const initialBlock: string = this.pipeElements[index].blockId.toString();
      this.connectionRoomService
        .getVideoFeedPromiseByBlockId(initialBlock)
        .then((videoFeed: Models.VideoFeed) => {
          this.videoFeeds[index] = videoFeed;
        });
    }

    private startGetDataInterval(): void {
      if (this.getDataTimer !== undefined) {
        this.$interval.cancel(this.getDataTimer);
      }

      this.getDataTimer = this.$interval(() => {
        this.getTrendingData();
      }, PipeViewerController.STREAM_DATA_TIMER);
    }

    private initTrending(): void {
      if (!this.getDataTimer) {
        this.startGetDataInterval();
      }
      if (
        !this.trendingInfo &&
        this.currentElementIndex !== undefined &&
        this.pipeElements[this.currentElementIndex] !== undefined
      ) {
        let blockId: number = this.pipeElements[this.currentElementIndex]
          .blockId;
        if (
          this.pipeElements[this.currentElementIndex].blockI.config
            .isRedundant == true
        ) {
          blockId = this.pipeElements[this.currentElementIndex].blockId - 1;
        }

        const blockHref: string = `blocks/${blockId}`;
        this.trendingInfo = new Models.TrendingInfo(
          this.streamStatusService,
          this.flexCollectorService,
          this.$timeout,
          this.$q,
          blockHref,
          180,
          true,
          (index: number) => {
            if (
              this.trendingInfo &&
              this.trendingInfo.lastBitrates &&
              this.trendingInfo.lastBitrates[index]
            ) {
              const lastBitrate = this.trendingInfo.lastBitrates[index].bitrate;
              this.currentBitrateMbps[index] = this.bitsToMbps(lastBitrate);
            }
          },
          ['bitrate']
        );
        this.trendingInfo.initTrendingData();
      }
    }

    private getTrendingData(): void {
      if (!this.trendingInfo) {
        this.initTrending();
      }
    }

    private bitsToMbps(bits: number): number {
      if (bits === null)
        // tslint:disable-line
        return null; // tslint:disable-line
      let value: number = parseFloat((bits / 1000000).toFixed(2));
      return isNaN(value) ? 0 : value;
    }

    private initBindings(): void {
      this.$scope.$on('$destroy', () => {
        if (this.getDataTimer !== undefined)
          this.$interval.cancel(this.getDataTimer);
        if (this.plotTimer !== undefined) this.$interval.cancel(this.plotTimer);
        if (this.profileInterval !== undefined)
          this.$interval.cancel(this.profileInterval);
        if (this.parseBlockInfoTimer !== undefined)
          this.$interval.cancel(this.parseBlockInfoTimer);
        if (this.trendingInfo) {
          this.trendingInfo.close();
          this.trendingInfo = undefined;
        }
        if (this.stompReconnectUnsubscribe !== undefined) {
          this.stompReconnectUnsubscribe();
        }
        if (this.timezoneChanged) {
          this.timezoneChanged();
        }
      });

      this.stompReconnectUnsubscribe = this.$rootScope.$on(
        'stompReconnect',
        () => {
          if (this.trendingInfo) {
            this.trendingInfo.closeAfterReconection();
            this.trendingInfo.initTrendingData();
          }
        }
      );

      this.timezoneChanged = this.$rootScope.$on('timezoneChanged', () => {
        this.reRender = false;
        if (this.trendingInfo) {
          this.trendingInfo.close();
          this.trendingInfo = undefined;
        }

        this.initTrending();
        this.$timeout(() => (this.reRender = true), 0);
      });
    }

    private initValues(): void {
      this.maxSynthValues = 2;
      this.numSynthValues = 0;
      this.changePipeStep(0); // This is overriding the cookie behavior.
      this.stepsInfo = [];
      this.blockAudios = [];
      this.txInfo = true;
      this.profilesEditionMode = false;

      this.fakePresets = [
        {
          name: 'Normal'
        },
        {
          name: 'High Profile'
        },
        {
          name: 'Streaming 720p'
        },
        {
          name: 'Poor quality'
        }
      ];
      this.userService.loadCurrentUser().then((user: Models.User) => {
        this.aclService
          .canRead('io.epiclabs.flex.api.WebApplication', 4)
          .then((can: boolean) => {
            this.canReadSupport = can;
          });
      });
    }

    private generateConnectionsInfo(): void {
      this.pipeElements.map((pe: Models.IStreamPipeElement) => {
        if (
          pe.outgoingConnection &&
          pe.outgoingConnection.origBlockConnection
        ) {
          let type: 'internet' | 'cable';
          let name: string =
            pe.outgoingConnection.origBlockConnection.connectionTypeName;
          switch (
            pe.outgoingConnection.origBlockConnection.connectionTypeName
          ) {
            case 'WMT bonding':
              type = 'internet';
              name = 'Bonding';
              break;
            case 'RTSP':
            case 'TSoIP':
              type = 'internet';
              break;
            case 'SDI':
            case 'ASI':
              type = 'cable';
              break;
            default:
          }
          pe.outgoingDigestedConnectionInfo = {
            type: type,
            name: name
          };
        } else {
          pe.outgoingDigestedConnectionInfo = undefined;
        }
      });
    }

    private probeOn(): void {
      this.probeSwitched(true);
    }

    private probeOff(): void {
      this.probeSwitched(false);
    }

    private probeSwitched(probeOn: boolean): void {
      if (
        this.pipeElements &&
        this.currentElementIndex !== undefined &&
        this.pipeElements[this.currentElementIndex]
      ) {
        let blockId: number = this.pipeElements[this.currentElementIndex]
          .blockId;
        if (
          this.pipeElements[this.currentElementIndex].blockI.config
            .isRedundant == true
        ) {
          blockId = this.pipeElements[this.currentElementIndex].blockId - 1;
        }
        const blockHref: string = `blocks/${blockId}`;
        this.hasTwoBitrates =
          probeOn &&
          this.pipeElements[this.currentElementIndex].blockI
            .blockTypeNaturalKey === BlockTypeNaturalKey.SRT_GW_RX_LSTN;
        let bitrateParams: string[];
        if (!probeOn && this.trendingInfo) {
          this.trendingInfo.clearProbedData();
        } else {
          if (probeOn) {
            bitrateParams = ['bitrate', 'probedBitrate'];
          } else {
            bitrateParams = ['bitrate'];
          }
          this.trendingInfo = new Models.TrendingInfo(
            this.streamStatusService,
            this.flexCollectorService,
            this.$timeout,
            this.$q,
            blockHref,
            180,
            true,
            (index: number) => {
              if (
                this.trendingInfo &&
                this.trendingInfo.lastBitrates &&
                this.trendingInfo.lastBitrates[index]
              ) {
                const lastBitrate = this.trendingInfo.lastBitrates[index]
                  .bitrate;
                this.currentBitrateMbps[index] = this.bitsToMbps(lastBitrate);
              }
            },
            bitrateParams
          );
          this.trendingInfo.initTrendingData();
        }
      }
    }
  }
}
